import { useEffect, useState } from "react";
import { TitleSection } from "../title-section";
import { motion } from "framer-motion";

export function CourseVideo() {
  const [dots, setDots] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => {
        if (prev.length >= 3) return "";
        return prev + ".";
      });
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <section
      id="estatisticas"
      className="w-full py-10 px-4 lg:mx-0 flex justify-center"
    >
      <div className="w-50 max-w-4xl flex flex-col items-center gap-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <TitleSection blueToRed first_title="Curso de elaboração de itens" />
        </motion.div>

        <motion.h5
          className="text-7xl text-center font-bold flex gap-2"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8, duration: 1 }}
        >
          EM BREVE<span>{dots}</span>
        </motion.h5>
      </div>
    </section>
  );
}
